import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UserPlus, Crosshair, ArrowRight } from "lucide-react";

export default function SigningAlertsCard() {
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    api.get("/scouting/rival-players?decision=fichar")
      .then((r) => setPlayers(r.data || []))
      .catch(() => setPlayers([]));
  }, []);

  if (players.length === 0) return null;

  return (
    <Card className="border-emerald-200 bg-emerald-50/40 shadow-sm" data-testid="signing-alerts-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-black flex items-center gap-2" style={{ fontFamily: "Nunito" }}>
          <span className="w-8 h-8 rounded-lg bg-emerald-600 grid place-items-center">
            <UserPlus className="h-4 w-4 text-white" />
          </span>
          Alertas de fichajes
          <span className="ml-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 border border-emerald-300 text-xs font-bold">
            {players.length}
          </span>
          <Button
            variant="ghost"
            size="sm"
            className="ml-auto text-emerald-700 hover:text-emerald-800 font-bold"
            onClick={() => navigate("/rivals")}
            data-testid="signing-alerts-goto"
          >
            Ver scouting <ArrowRight className="h-4 w-4 ml-1" />
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <p className="text-xs text-slate-500 mb-3">
          Jugadores rivales marcados como <b>Fichar</b> en la base de scouting.
        </p>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {players.slice(0, 8).map((rp) => (
            <li
              key={rp.id}
              className="flex items-center gap-3 p-2.5 rounded-lg bg-white border border-emerald-100"
              data-testid={`signing-alert-${rp.id}`}
            >
              <div className="w-8 h-8 rounded-md bg-emerald-100 text-emerald-700 grid place-items-center shrink-0">
                <Crosshair className="h-4 w-4" />
              </div>
              <div className="min-w-0">
                <div className="font-bold text-sm text-slate-900 truncate">{rp.name}</div>
                <div className="text-[11px] text-slate-500 truncate">
                  {[rp.position, rp.birth_year, rp.rival_team,
                    [rp.category, rp.sub_category].filter(Boolean).join(" · ")]
                    .filter(Boolean).join(" · ")}
                </div>
              </div>
            </li>
          ))}
        </ul>
        {players.length > 8 && (
          <div className="text-[11px] text-slate-500 mt-2">
            y {players.length - 8} más en la base de scouting…
          </div>
        )}
      </CardContent>
    </Card>
  );
}
